import React, { useState } from 'react';
import { db } from '../Components/auth/firebaseConfig';
import { collection, addDoc } from 'firebase/firestore';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useNavigate } from 'react-router-dom';

function AddBoardAccess() {
  // State to hold the details of the board
  const [boardDetails, setBoardDetails] = useState({
    boardNo: '',         // Board number
    boardName: '',       // Name of the board
    accessGroups: [],    // Array to hold access groups (not currently used)
    isPublic: true,      // Boolean to indicate if the board is public
  });
  
  // useNavigate hook for navigation
  const navigate = useNavigate();

  // Function to handle input changes in the form fields
  const handleInputChange = (event) => {
    const { name, value } = event.target; // Destructure name and value from the event target
    setBoardDetails(prevDetails => ({
      ...prevDetails, // Spread previous state
      [name]: value,  // Update the field based on input name
    }));
  };

  // Function to handle the switch toggle for public/private board
  const handleSwitchChange = (event) => {
    setBoardDetails(prevDetails => ({
      ...prevDetails,
      isPublic: event.target.checked, // Update isPublic state based on switch
    }));
  };

  // Function to handle form submission
  const handleSubmit = async () => {
    try {
      // Add the new board document to the Firestore collection
      await addDoc(collection(db, 'boards'), boardDetails);
      // Navigate to the Board Access page after successful submission
      navigate('/board-access'); 
    } catch (error) {
      // Log any errors encountered during submission
      console.error('Error adding board: ', error);
    }
  };

  return (
    <Box>
      {/* Title of the form */}
      <Typography variant="h4" gutterBottom>
        Add New Board Access
      </Typography>
      {/* Input field for Board Number */}
      <TextField
        autoFocus
        margin="dense"
        name="boardNo"
        label="Board No#"
        fullWidth
        variant="outlined"
        value={boardDetails.boardNo}
        onChange={handleInputChange} // Handle input changes
      />
      {/* Input field for Board Name */}
      <TextField
        margin="dense"
        name="boardName"
        label="Board Name"
        fullWidth
        variant="outlined"
        value={boardDetails.boardName}
        onChange={handleInputChange} // Handle input changes
      />
      {/* Switch to toggle between public/private board */}
      <FormControlLabel
        control={
          <Switch
            checked={boardDetails.isPublic}
            onChange={handleSwitchChange} // Handle switch toggle
            color="primary"
          />
        }
        label="Is Public?"
      />
      {/* Button section for submission and cancellation */}
      <Box mt={2}>
        {/* Submit button to add the new board */}
        <Button
          onClick={handleSubmit}
          color="success"
          variant="contained"
          sx={{ mr: 2 }} // Add margin to the right
        >
          Submit
        </Button>
        {/* Cancel button to navigate back to Board Access page */}
        <Button
          onClick={() => navigate('/board-access')}
          color="error"
          variant="outlined"
        >
          Cancel
        </Button>
      </Box>
    </Box>
  );
}

export default AddBoardAccess;
